<template>
    <v-container fluid>
        <v-card class="header-card">
            <v-card-title class="card-title">Faqs</v-card-title>
            <div class="header-buttons">
                <v-btn class="my-2 mr-2" dark small color="black" @click="createFaq">
                    <v-icon dark>mdi-plus</v-icon>Create
                </v-btn>
            </div>
        </v-card>
        <array-view
            :items="faqs"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @handleClick="handleClick"
            @onDelete="onDelete"
            @paginationChange="paginationChange"
        />
    </v-container>
</template>

<script>
    import faqService from '@/services/faq'
    import ArrayView from '@/components/ArrayView'

    export default {
        name: 'Faq',
        components: { ArrayView },
        data: () => {
            return {
                successfullImport: null,
                faqs: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Question',
                        value: 'question'
                    },
                    {
                        text: 'Answer',
                        value: 'aswer'
                    },
                    {
                        text: 'Type',
                        value: 'type'
                    }
                ],
                showImportDialog: false,
                size: 100,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.page = this.$store.getters.getPage
            this.fetchAllFaqs()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchAllFaqs()
            },
            handleClick(action, item) {
                this.$router.push(`/faqs/${item.id}/${action}`)
            },
            createFaq() {
                this.$router.push(`/faqs/create`)
            },
            fetchAllFaqs() {
                faqService.getFaqs(this.page, this.size).then(resp => {
                    this.faqs = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            onDelete(faq) {
                faqService.deleteFaq(faq.id).then(resp => {
                    this.fetchAllFaqs()
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
